import fetchShares from './fetch-shares';

export default function fetchRecentShares(options) {
  return fetchShares({
    sort: 'ratePerHour',
    sortDir: 'asc',
    ...options
  });
}
